import React from "react";
import { PhoneIcon } from "./icons";

// Bouton avec le numéro affiché. Le PREMIER <span> du lien doit contenir le numéro :
// le script de suivi le remplace et le met en blanc. Le libellé est dans un <small>.
export function PhoneButton({ phone, label }) {
  return (
    <a href={phone.href} className="btn-number">
      <span className="num">{phone.display}</span>
      <small>{label}</small>
    </a>
  );
}

// Bouton d'appel sans numéro affiché.
export function CallButton({ phone, label, className = "" }) {
  return (
    <a href={phone.href} className={"btn-call " + className}>
      <PhoneIcon size={18} />
      <b>{label}</b>
    </a>
  );
}
